import { Link } from 'react-router-dom';
import { Newspaper, Calendar, ArrowRight } from 'lucide-react';

const pressReleases = [
  {
    id: 'out-of-bounds',
    slug: 'out-of-bounds',
    date: 'September 21, 2026',
    title: 'Players Health Foundation Launches Capital Campaign for "Out of Bounds," a Feature Documentary on the Fight to Reclaim Youth Sports',
    excerpt: '$750,000 campaign to fund a feature documentary on the youth sports boom, the harm it has left behind, and the movement working to give the game back to kids.',
    tag: 'Press Release'
  },
  {
    id: 'fall-grantees-2026',
    slug: 'fall-grantees-2026',
    date: 'September 3, 2026',
    title: 'Players Health Foundation Awards $100,000 in Grants to 20 Youth Sports Organizations Nationwide',
    excerpt: 'Inaugural grant class reflects the Foundation\'s mission to protect athletes and expand access to sport in communities nationwide.',
    tag: 'Press Release'
  },
  {
    id: 'pca-partnership',
    slug: 'pca-partnership',
    date: 'August 14, 2026',
    title: 'Players Health Foundation and Positive Coaching Alliance Partner to Pair Athlete Safety Grants With Coach Education',
    excerpt: 'Foundation is contributing to PCA and will help cover the cost of PCA\'s coaching curriculum for its grant recipients.',
    tag: 'Partnership'
  },
  {
    id: 'grant-program-launch',
    slug: 'press-release',
    date: 'May 21, 2026',
    title: 'Players Health Foundation Launches $100,000 Grant Program to Protect Young Athletes',
    excerpt: 'Twenty grants of $5,000 each will fund youth sports organizations committed to athlete safety, training support, and community impact.',
    tag: 'Press Release'
  }
];

export const Newsroom = () => {
  return (
    <div className="pt-20" data-testid="newsroom-page">
      {/* Hero Section */}
      <section className="py-20 md:py-32 bg-zinc-50">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="max-w-3xl">
            <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#5B4FF9] mb-4">
              Newsroom
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-extrabold text-[#272926] leading-tight mb-6">
              Latest News & Updates
            </h1>
            <p className="text-xl leading-relaxed text-zinc-600">
              Stay up to date with the latest announcements, partnerships, and stories from the Players Health Foundation.
            </p>
          </div>
        </div>
      </section>

      {/* Press Releases Grid */}
      <section className="py-20 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {pressReleases.map((release) => (
              <Link
                key={release.id}
                to={`/newsroom/${release.slug}`}
                className="block bg-white border border-zinc-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all hover:-translate-y-1 group"
                data-testid={`newsroom-${release.id}`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#F5F4FF] rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-[#5B4FF9] transition-colors">
                    <Newspaper className="h-6 w-6 text-[#5B4FF9] group-hover:text-white transition-colors" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs font-semibold text-[#5B4FF9] bg-[#F5F4FF] px-2 py-1 rounded-full">
                        {release.tag}
                      </span>
                      <span className="text-xs text-zinc-500 flex items-center">
                        <Calendar className="h-3 w-3 mr-1" />
                        {release.date}
                      </span>
                    </div>
                    <h3 className="text-lg font-bold text-[#272926] mb-2 group-hover:text-[#5B4FF9] transition-colors">
                      {release.title}
                    </h3>
                    <p className="text-zinc-600 text-sm leading-relaxed">
                      {release.excerpt}
                    </p>
                    <span className="inline-flex items-center text-[#5B4FF9] font-semibold text-sm mt-4">
                      Read more
                      <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
